"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styledComponents_1 = require("./styledComponents");
var CustomInProgress = function (_a) {
    var text = _a.text, _b = _a.variant, variant = _b === void 0 ? 'disable' : _b;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        text,
        react_1["default"].createElement(styledComponents_1.Wrapper, null,
            react_1["default"].createElement(styledComponents_1.InProgressEllipse, { delay: 0, variant: variant }),
            react_1["default"].createElement(styledComponents_1.InProgressEllipse, { delay: 2, variant: variant }),
            react_1["default"].createElement(styledComponents_1.InProgressEllipse, { delay: 4, variant: variant }))));
};
exports["default"] = CustomInProgress;
